import { useLocation } from 'react-router-dom';
import { isExternalPath, isPathActive } from '../utils/navigation';

// ----------------------------------------------------------------------

export default function useActiveLink(path, deep = true) {
  const { pathname } = useLocation();

  // Verificar se path está definido
  if (!path) {
    return {
      active: false,
      isExternalLink: false,
    };
  }

  if (isExternalPath(path)) {
    return {
      active: false,
      isExternalLink: true,
    };
  }

  return {
    active: isPathActive(pathname, path, deep),
    isExternalLink: false,
  };
}
